import { render } from "./CotizacionPreview.vue?vue&type=template&id=7da0d670"
import script from "./CotizacionPreview.vue?vue&type=script&lang=js"
export * from "./CotizacionPreview.vue?vue&type=script&lang=js"

import "./CotizacionPreview.vue?vue&type=style&index=0&id=7da0d670&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__